import { useState } from "react";
import EditDate from "../candidateDateComponents/editDate";
import DisplayEditableDate from "../candidateDateComponents/displayEditableDate";
import { CandidateFieldLabel } from "../candidateFieldLabel/candidateFieldLabel";

export const CandidateDateField = ({
  label,
  dateKey,
  value,
  candidateJobEntryId,
  onUpdated,
  isOtherItem,
  itemType,
  jobId,
  isTime,
  isEditable,
  disabled = false,
}) => {
  const [isEdit, setIsEdit] = useState(false);

  const renderValue = () => {
    if (isEdit) {
      return (
        <EditDate
          isTime={isTime}
          dateKey={dateKey}
          onCancel={() => setIsEdit(false)}
          dateString={value}
          candidateJobEntryId={candidateJobEntryId}
          onUpdated={onUpdated}
          isOtherItem={isOtherItem}
          itemType={itemType}
          jobId={jobId}
        />
      );
    }

    return (
      <DisplayEditableDate
        isTime={isTime}
        onEdit={() => setIsEdit(true)}
        isEditable={isEditable}
        dateString={value}
        isOtherItem={isOtherItem}
        disabled={disabled}
      />
    );
  };

  return (
    <div>
      <CandidateFieldLabel>{label}</CandidateFieldLabel>
      {renderValue()}
    </div>
  );
};
